<template>
    <v-form v-model="valid"
            :class="{
                'disabled': loading
            }"
            @submit.prevent="submitProfile"
    >
        <div class="basic-tab-info">
            <section>
                <div id="paypal-button-container"></div>
                <div class="basic-info">
                    <div :class="'basic-info-image' + (form.picture ? ' uploaded' : '')"
                         :style="`background-image: url(${
                            form.picture
                                ? (form.picture.startsWith('http')
                                    ? ''
                                    : 'data:image/png;base64,')
                                + form.picture
                            : ''
                            });`"
                    >
                        <div class="actions">
                            <input type="file"
                                   ref="image_uploader"
                                   required
                                   @change="upload"
                            />
                            <v-btn color="#000"
                                   flat
                                   @click.native="$refs.image_uploader.click()"
                            >
                                {{ $t('Send profile picture') }}
                            </v-btn>
                            <small>{{ $t('send_profile_pic_note') }}</small>
                        </div>
                    </div>
                    <div class="basic-info-inputs">
                        <v-text-field
                            prepend-icon="fa-user-circle"
                            class="profile_name"
                            v-model="form.name"
                            :label="(info['media_type'] === 'image'
                                ? $t('Author\'s name')
                                : $t('Professional or company name')
                            )+' *'"
                            :rules="[form_rules.required]"
                            :hint="info['media_type'] === 'image' ? $t('Company name or joint name are not allowed') : ''"
                            :persistent-hint="info['media_type'] === 'image'"
                        ></v-text-field>
                        <v-text-field
                            prepend-icon="fa-phone"
                            v-model="form.phone"
                            :mask="form.country !== 'Brasil' ? '' : '(##) #####-####'"
                            :label="$t('Phone number')+' *'"
                            :rules="[form_rules.required]"
                        ></v-text-field>
                        <v-text-field
                            prepend-icon="fa-globe"
                            v-model="form.website"
                            label="Website *"
                            :rules="[form_rules.required, form_rules.url]"
                        ></v-text-field>
                    </div>
                </div>
                <v-text-field
                    v-if="form.country !== 'Brasil'"
                    readonly
                    disabled
                    prepend-icon="fa-map"
                    v-model="form.country"
                    :label="$t('Country')+' *'"
                    :rules="[form_rules.required]"
                ></v-text-field>
                <v-select
                    v-else
                    prepend-icon="fa-map"
                    :items="states"
                    item-text="state"
                    item-value="abbr"
                    v-model="form.state"
                    label="Estado *"
                    :rules="[form_rules.required]"
                ></v-select>
                <v-text-field
                    prepend-icon="fa-map-pin"
                    v-model="form.city"
                    :label="$t('City')+' *'"
                    :rules="[form_rules.required]"
                ></v-text-field>
            </section>
            <section>
                <v-text-field
                    prepend-icon="fab fa-facebook"
                    v-model="form.facebook"
                    label="Facebook"
                    :rules="[form_rules.facebook]"
                ></v-text-field>
                <v-text-field
                    prepend-icon="fab fa-instagram"
                    v-model="form.instagram"
                    label="Instagram"
                    :rules="[form_rules.instagram]"
                ></v-text-field>
                <v-select
                    class="large_input"
                    prepend-icon="fa-palette"
                    :items="themes"
                    item-text="name"
                    item-value="value"
                    v-model="form.theme"
                    :label="$t('Theme')+' *'"
                    :rules="[form_rules.required]"
                    :hint="$t('Choose a colorway theme for your profile')"
                    :persistent-hint="true"
                ></v-select>
                <v-text-field
                    class="large_input"
                    prepend-icon="fab fa-youtube"
                    v-model="form.presentation_video"
                    :label="$t('Presentation video')"
                    :hint="$t('presentation_video_hint')"
                    :persistent-hint="true"
                ></v-text-field>
            </section>
        </div>
        <v-alert
            v-if="!valid"
            :value="true"
            type="info"
            class="notranslate"
        >{{ $t('Fill in all required fields to save your profile') }}</v-alert>
        <v-alert
            v-if="error"
            :value="true"
            type="error"
            class="notranslate"
        >{{ error }}</v-alert>
        <v-btn type="submit"
               style="color: #fff;"
               :loading="loading"
               :disabled="!canSubmit"
               color="accent"
        >{{ $t('Submit') }}</v-btn>
    </v-form>
</template>

<script>
  import {
    brStates,
    themes
  } from "../utils/strings";
  import Banner from './Banner'
  import VTextarea from "vuetify/es5/components/VTextarea/VTextarea";
  import VSelect from "vuetify/es5/components/VSelect/VSelect";
  import VForm from "vuetify/es5/components/VForm/VForm";
  import VTextField from "vuetify/es5/components/VTextField/VTextField";
  import VAlert from "vuetify/es5/components/VAlert/VAlert";
  import { validateImage } from "../utils/functions";
  import form_rules_mixin from "../utils/form_rules_mixin";
  import SpecialOfferAlert from "./SpecialOfferAlert";
  export default {
    name: "ProfileBasic",
    components: {
      SpecialOfferAlert,
      Banner,
      VTextarea,
      VSelect,
      VForm,
      VTextField,
      VAlert
    },
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      error: {
        type: Boolean,
        required: true
      },
      info: {
        type: Object,
        required: true
      },
      offers_basic_plan: {
        type: Boolean,
        required: true
      }
    },
    mixins: [
      form_rules_mixin
    ],
    data: () => ({
      form: {
        name: '',
        phone: '',
        picture: '',
        website: '',
        facebook: '',
        instagram: '',
        country: '',
        city: '',
        state: '',
        theme: '',
        presentation_video: ''
      },
      valid: false,
      states: brStates,
      themes: themes
    }),
    computed: {
      canSubmit: function () {
        return this.valid && this.form && !this.loading;
      }
    },
    methods: {
      upload: function () {
        validateImage(this.$refs.image_uploader.files[0], 480, 480, 48)
          .then(data => {
            this.form.picture = data
          })
          .catch(() => {
            window.alert(this.$t('There is a problem with the picture you sent'))
          })
      },
      submitProfile: function () {
        this.$emit('submit-profile', this.form)
      },
      showPlansComparison: function () {
        this.$emit('show-plans-comparison')
      },
      payMembership: function () {
        this.$emit('pay-membership')
      },
    },
    mounted () {
      if (this.info) {
        Object.keys(this.form).map(key => {
          let value = this.form[key]
          if (key === 'country') {
            this.form.country = this.info.country.name
          } else {
            this.form[key] = this.info[key]
          }
        })
      }
    }
  }
</script>

<style lang="scss">
    .v-form {
        .v-input {
            margin: 12px 0;
        }
        .v-input.large_input {
            margin: 30px 0;
        }
        &.disabled {
            pointer-events: none;
            opacity: 0.6;
        }
        button[type=submit] {
            display: block;
            margin: 24px auto 0;
        }
        .basic-tab-info {
            margin: 24px 12px;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 32px;
            .basic-info {
                clear: both;
                margin-bottom: 24px;
                .basic-info-image {
                    float: left;
                    border-radius: 50%;
                    position: relative;
                    overflow: hidden;
                    background-size: cover;
                    @media only screen and (max-width: 1259px) {
                        margin: 28px 12px 28px 0;
                        width: 180px;
                        height: 180px;
                    }
                    @media only screen and (min-width: 1260px) {
                        margin-right: 24px;
                        width: 215px;
                        height: 215px;
                    }
                    .actions {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        opacity: 0;
                        background: rgba(255,255,255,0.75);
                        transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                        color: #000;
                        input {
                            display: none;
                        }
                        button {
                            margin: 0;
                        }
                        small {
                            text-align: center;
                            padding: 0 6px;
                        }
                    }
                    &:hover .actions {
                        opacity: 1;
                    }
                    &:not(.uploaded) .actions {
                        opacity: 1;
                        background: rgba(0,0,0,0.12);
                    }
                }
                .basic-info-inputs {
                    .v-input.profile_name .v-messages__wrapper {
                        color: var(--accent-color);
                        font-weight: bold;
                    }
                }
            }
        }
    }
</style>

<i18n>
    {
        "en": {
            "Limited time annuity special offer": "Limited time annuity special offer",
            "discount_off": "off",
            "Send profile picture": "Send profile picture",
            "send_profile_pic_note": "Image must be .jpg and 480x480",
            "Author's name": "Author's name",
            "Professional or company name": "Professional or company name",
            "Company name or joint name are not allowed": "Company name or joint name are not allowed",
            "Phone number": "Phone number",
            "Country": "Country",
            "City": "City",
            "Theme": "Theme",
            "Choose a colorway theme for your profile": "Choose a colorway theme for your profile",
            "Presentation video": "Presentation video",
            "presentation_video_hint": "Optional: Submit a Vimeo or Youtube video to introduce yourself to your customers",
            "Fill in all required fields to save your profile": "Fill in all required fields to save your profile",
            "There is a problem with the picture you sent": "There is a problem with the picture you sent. Verify the requirements and try again."
        },
        "pt": {
            "Limited time annuity special offer": "Oferta especial na anuidade por tempo limitado",
            "discount_off": "de desconto",
            "Send profile picture": "Enviar foto de perfil",
            "send_profile_pic_note": "Imagem deve ser .jpg e 480x480",
            "Author's name": "Nome do autor",
            "Professional or company name": "Nome profissional ou da empresa",
            "Company name or joint name are not allowed": "Não é permitido nome de empresas ou nomes conjugados",
            "Phone number": "Número de telefone",
            "Country": "País",
            "City": "Cidade",
            "Theme": "Tema",
            "Choose a colorway theme for your profile": "Escolha um tema de cores para o seu perfil",
            "Presentation video": "Vídeo de apresentação",
            "presentation_video_hint": "Opcional: Envie um vídeo do Youtube ou Vimeo para se apresentar aos seus clientes",
            "Fill in all required fields to save your profile": "Preencha todos os campos obrigatórios para salvar seu perfil",
            "There is a problem with the picture you sent": "Houve um problema com a foto que você enviou. Verifique os requeriemntos e tente novamente."
        }
    }
</i18n>
